module.exports = __webpack_public_path__ + "img/TeamWork.8a1797d1.svg";